<div class="flex flex-col gap-6">
  <div>
    <div class="font-bold uppercase">Biuro obsługi klienta:</div>

    <app-footer-link
      link="mailto:kontakt@purebeauty.pl"
      text="kontakt@purebeauty.pl" />
  </div>

  <div>
    <div>
      <div class="font-bold uppercase">Kontakt dla marek kosmetycznych:</div>

      <app-footer-link
        link="mailto:kwasny.beata@purebeauty.pl"
        text="kwasny.beata@purebeauty.pl" />
    </div>

    <div>
      <div class="font-bold uppercase">Niekosmetycznych:</div>

      <app-footer-link
        link="mailto:agata@purebeauty.pl"
        text="agata@purebeauty.pl" />
    </div>
  </div>

  <div>
    <div class="font-bold uppercase">Kontakt dla influencerów:</div>

    <app-footer-link
      link="mailto:monika@purebeauty.pl"
      text="monika@purebeauty.pl" />
  </div>

  <div>
    <div class="font-bold uppercase">Kontakt dla mediów:</div>

    <app-footer-link
      link="mailto:malwina@purebeauty.pl"
      text="malwina@purebeauty.pl" />
  </div>
</div>
